const PATH =
  'fe.pages.testing.reliability.score_report.result_section.pass_attempt_message';

const messages = {
  certificationPageBefore: {
    key: `${PATH}.certification_page_before`,
    defaultValue:
      'To view and manage all your certifications, including when to recertify and access to your observer cards, visit the'
  },
  certificationPageLink: {
    key: `${PATH}.certification_page_link`,
    defaultValue: 'Certifications'
  },
  certificationPageAfter: {
    key: `${PATH}.certification_page_after`,
    defaultValue: ' page.'
  },
  attemptTip: {
    key: `${PATH}.attempt_tip`,
    defaultValue: 'Attempt tip icon'
  }
};

export default messages;
